<template comments>
  <div v-show="show" class="popbox-video show" @click.stop>
    <div class="popbox-dialog">
      <div class="popbox-inner">
        <div id="videoContainer" class="video-wrap" :style="videoStyle"></div>
      </div>
      <div class="popbox-close" @click="close"></div>
    </div>
    <div class="act-mask" @click="close"></div>
  </div>
</template>

<script>
import { dialogNoScroll } from '@/libs/utils';
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    videoId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      player: '',
      videoStyle: ''
    };
  },
  watch: {
    show(value) {
      dialogNoScroll(value);
      if (value) {
        // 创建视频
        this.setVideoPosition();
      }
    }
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      if (this.show) {
        this.setVideoPosition(false);
      }
    },
    setVideoPosition(setVideo = true) {
      // ios wechart 旋转innerWidth取值问题
      setTimeout(() => {
        const height = Math.min(
          window.innerWidth * (9 / 16),
          window.innerHeight
        );
        this.videoStyle = `height: ${height}px`;
        if (setVideo) {
          this.setTxPlayer();
        }
      }, 200);
    },
    setTxPlayer() {
      if (this.player) {
        this.player.seekTo && this.player.seekTo(0); // 从头开始播放
        this.player.play({ vid: this.videoId });
        return;
      }
      if (window && window.Txplayer) {
        // eslint-disable-next-line no-new
        this.player = new window.Txplayer({
          containerId: 'videoContainer',
          vid: this.videoId,
          width: '100%',
          height: '100%',
          disablepip: 1,
          autoplay: true
        });
      }
    },
    close() {
      try {
        // 暂停视频
        this.player.pause();
        this.$emit('update:show', false);
      } catch (error) {
        this.$emit('update:show', false);
      }
    }
  }
};
</script>
